import React from 'react'

//Styles
import './PaymentIncludedTournamentsComponent.styles.css';

//i18
import { withTranslation } from 'react-i18next';

// Functions
import { getRandonIconBallColor } from 'shared/functions/GetRandomIconColor';


function PaymentIncludedTournamentsComponent(props) {


    return (
        <div className='payment-included-tournaments__container'>
            <div className='payment-included-tournaments__title'>
                <span className='icon-trophy'/>
                <div className='baloa-table'>{props.t('paymentDetailModal.includedTournamentsSubTitle')}</div>
            </div>
            {props.tournaments?.map( tournament =>
                <div className='payment-included-tournaments__tournament'>
                    <div className='payment-included-tournaments__tournament-img'>
                        { tournament.tournament_logo
                            ? <img src={tournament.tournament_logo} alt={`${tournament.tournament_name} logo`} />
                            : <span className='icon-ball' color={getRandonIconBallColor()} />
                        }
                    </div>
                    <div className='payment-included-tournaments__tournament-data'>
                        <div className='baloa-table' >{tournament.tournament_name   }</div>
                        <div className='payment-included-tournaments__tournament-data__char'>
                            <div className='baloa-mini'>{props.t(`league:options.tournaments.pages.newTournament.tabs.tabBasicData.${tournament.tournament_football_type}`)}</div>
                            <div className='baloa-mini'>{props.t(`league:options.tournaments.pages.newTournament.tabs.tabBasicData.${tournament.tournament_gender}`)}</div>
                            <div className='baloa-mini'>{props.t(`league:options.tournaments.pages.newTournament.tabs.tabTeams.${tournament.tournament_category}`)}</div>
                        </div>
                    </div>
                </div>
            )
            }
        </div>
    )
}

export default withTranslation('payments')(PaymentIncludedTournamentsComponent)